<template>
  <section v-show="!$root.show_header" class="container mid-container">
    <table>
      <thead>
        <tr>
          <th></th>
        </tr>
      </thead>
      <tbody>
        <tr v-for="file in files" :class="{'expired': file.expired}">
          <td>
            <dl>
              <dt>
                <i v-show="!file.success && !file.error && !file.expired" class="icon-spin1 animate-spin" aria-hidden="true"></i>
                <i v-show="file.success && !file.accessed && !file.expired" class="icon-circle-empty green" aria-hidden="true"></i>
                <i v-show="file.success && file.accessed && !file.expired" class="icon-ok-circled2 green" aria-hidden="true"></i>
                <i v-show="file.error || file.expired" class="icon-cancel-circled2 red" aria-hidden="true"></i>
                <span class="file-name break-line">{{file.name}}</span>
              </dt>
              <dt class="file-link-section">
                <small>
                  <a class="file-link" v-show="file.upload_token" :href="$root.config.file_endpoint + '/f/' + file.upload_token + '.' + file.extension" target="_blank">
                    {{$root.config.file_endpoint}}/f/{{file.upload_token}}.{{file.extension}}
                  </a>
                  <div class="progress-outer" v-show="!file.upload_token && !file.error">
                    <div class="progress-inner" :style="{width: files_index[file.file_id].progress + '%'}">
                  </div>
                  <span class="break-line" v-show="file.error">{{file.error | capitalize}}</span>
                </small>
              </dt>
              <dt>
                <div v-show="file.success && !file.expired" class="file-controls float-right">
                  <!-- <button class="button button-outline"><i class="icon-docs"></i></button> -->
                  <a :href="$root.config.file_endpoint + '/f/' + file.upload_token + '.' + file.extension" target="_blank"
                      class="button button-small button-outline grey-border blue">
                    View ({{file.accessed}})
                  </a>
                  <button class="button button-small button-outline grey-border red"
                          @click="deleteUpload(file)">
                    <!-- <i class="icon-cancel-circled2"></i> -->
                    Delete
                  </button>
                </div>
              </dt>
            </dl>
          </td>
        </tr>
      </tbody>
    </table>
  </section>
</template>

<script>

import Vue from 'vue';
import Dropzone from 'dropzone';
import io from 'socket.io-client';

Dropzone.autoDiscover = false;

let DZ;
let socket;
let init_token = '';

export default {

  props: ['showHeader'],

  data () {
    return {
      counter: 0,
      files_index: {},
      files: []
    };
  },

  methods: {
    deleteUpload: (file) => {
      if (socket && file && file.upload_token) {
        file.expired = true;
        socket.emit('upload_delete', {
          'upload_token': file.upload_token
        });
      }
    }
  },

  created() {
    socket = io(this.$root.config.api_endpoint);

    socket.on('token', (data) => {

      data = data || {};

      if (data.type === 'new') {

        if (DZ) {
          DZ.options.headers['TEMPd-Token'] = data.tempd_token;
        } else {
          init_token = data.tempd_token;
        }

      } else if (data.type === 'refresh') {

        socket.emit('token_refresh', {
          'token': data.token
        });

      }
    });

    socket.on('upload', (data) => {
      if (data.type === 'expire') {
        for (let file of this.files) {
          if (file.upload_token === data.upload_token) {
            file.expired = true;
          }
        }
      } else if (data.type === 'accessed') {
        for (let file of this.files) {
          if (file.upload_token === data.upload_token) {
            file.accessed += 1;
          }
        }
      }
    });
  },

  ready () {
    DZ = new Dropzone(document.body, {
      url: this.$root.config.api_endpoint + '/api/upload',
      maxFilesize: 10,
      clickable: '#upload',
      headers: {
        'TEMPd-Token': init_token
      },
      addedfile: (file) => {

        if (this.$root.show_header) {
          this.$root.show_header = false;
        }

        file.file_id = ++this.counter;

        Vue.set(this.files_index, file.file_id, {
          progress: 0
        });

        this.files.unshift({
          file: file,
          file_id: file.file_id,
          name: file.name,
          upload_token: '',
          extension: '',
          accessed: 0,
          progress: 0,
          success: false,
          error: false,
          expired: false
        });

      },
      uploadprogress: (file, progress, bytes) => {
        this.files_index[file.file_id].progress = progress;
      },
      success: (file, response) => {

        for (let init_file of this.files) {
          if (init_file.file === file) {
            init_file.upload_token = response.upload_token;
            init_file.extension = response.extension;
            init_file.success = true;
          }
        }

      },
      error: (file, response, xhr) => {

        for (let init_file of this.files) {
          if (init_file.file === file) {
            if (xhr) {
              init_file.error = response.error;
            } else {
              init_file.error = response;
            }
            init_file.expired = true;
          }
        }

      }
    });
  }
};
</script>

<style scoped>

.no-padding-top {
  padding-top: 0px;
}

.file-link-section {
  margin-left: 27px;
}

<style scoped>

.fade-transition {
  transition: all .5s ease;
  overflow: hidden;
  margin: 0;
  height: 7.5rem;
}
.fade-enter, .fade-leave {
  opacity: 0;
  height: 0;
}

tr.expired .file-name, tr.expired .file-link {
  text-decoration: line-through;
}

/* https://css-tricks.com/snippets/css/prevent-long-urls-from-breaking-out-of-container/ */

.break-line {
  overflow-wrap: break-word;
  -ms-word-break: break-all;
  word-break: break-all;
  -ms-hyphens: auto;
  -moz-hyphens: auto;
  -webkit-hyphens: auto;
  hyphens: auto;
}

.button.button-outline.grey-border.blue:hover {
  border-color: #3da5fb;
  color: #3da5fb;
}

.button.button-outline.grey-border.blue:focus {
  border-color: #e1e1e1;
  color: #3da5fb;
}

.button.button-outline.red {
  color: red;
}

.button.button-outline.red:hover {
  border-color: red;
}

/* progress bar */

.progress-outer{
  width: 100%;
  height: 0.2em;
  background-color: #fffff;
}

.progress-inner {
  height: 0.2em;
  background-color: #3da5fb;
}
</style>



/** WEBPACK FOOTER **
 ** MainView.vue?f8d7243e
 **/